import React from "react";
import {Form} from 'react-bootstrap';

function STCFormGroup(props){

    return(
        <Form.Group
            style={props.style}
            className={props.className}
            controlId={props.controlId}
            required={props.required}

            as={props.as}
        >
            {props.children}
        </Form.Group>
    )

}
export default STCFormGroup;